<template>
  <div class="col-md-2 col-sm-6 col-xs-6 mobile">
    <span v-if="!label">Grupo</span>
    <q-select
      dense
      outlined
      v-model="grupo"
      @input-value="setModel"
      :options="listaGrupos"
      use-input
      input-debounce="0"
      hide-selected
      fill-input
      option-label="nome"
      option-value="uuid"
      :label="label"
      :hint="hint"
      @filter="filterFn"
      @filter-abort="abortFilterFn"
      map-options
      :rounded="rounded"
    >
    </q-select>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";

export default {
  name: "SelectComponentGrupos",
  emits: ["emitirGrupo"],
  props: [
    "uuid",
    "model",
    "subGrupoCategoriaUuid",
    "resetar",
    "hint",
    "label",
    "rounded",
  ],

  setup(props, { emit }) {
    const store = useStore();
    const listaGrupos = ref([]);
    const lista = ref([]);
    const time = ref();
    const grupo = ref(props.model);

    watch(
      () => grupo.value,
      () => {
        emit("emitirGrupo", grupo.value);
      }
    );

    watch(
      () => props.uuid,
      () => {
        consultarGrupo(props.uuid);
      }
    );

    watch(
      () => props.resetar,
      () => {
        grupo.value = "";
      }
    );

    watch(
      () => props.atualizarCategoria,
      () => {
        buscarCategoria(props.subGrupoCategoriaUuid);
      }
    );

    const listarCategorias = async (val) => {
      if (val === "") {
        listaGrupos.value = [];
        grupo.value = "";
        return;
      }
      try {
        listaGrupos.value = [];
        let resposta = await store.dispatch("fer/listarCategorias", {
          per_page: 100000,
          nome: val,
        });
        listaGrupos.value = resposta.data.result.data;
        grupo.value = resposta.data.result.data[0];
      } catch (error) {
        console.log(error);
      }
    };

    const buscarCategoria = async (id) => {
      if (id === "") {
        return;
      }
      try {
        const response = await store.dispatch("fer/detalharCategoria", {
          categoriaUuid: id,
        });
        grupo.value = response.data.result;
      } catch (error) {
        console.log(error);
      }
    };

    let consultarGrupo = async (id) => {
      let resposta = await store.dispatch("fer/consultarGrupo", {
        uuid: id,
      });
      grupo.value = resposta.grupo;
    };

    watch(
      () => props.model,
      () => {
        grupo.value = props.model;
      }
    );

    watch(
      () => props.subGrupoCategoriaUuid,
      () => {
        if (props.model && grupo.value) {
          return;
        }
        if (
          grupo.value == undefined ||
          grupo.value == "" ||
          (grupo.value == null &&
            props.subGrupoCategoriaUuid != null &&
            props.subGrupoCategoriaUuid != "")
        ) {
          buscarCategoria(props.subGrupoCategoriaUuid);
        }
      }
    );

    return {
      listaGrupos,
      grupo,
      consultarGrupo,
      lista,
      listarCategorias,
      filterFn(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }

        time.value = setTimeout(() => {
          listarCategorias(val);
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);
      },
      setModel(val) {
        if (val === "") {
          grupo.value = val;
        }
      },
      abortFilterFn() {
        // console.log('delayed filter aborted')
      },
      buscarCategoria,
    };
  },
};
</script>

<style scoped>
@media (max-width: 1343px) {
  .mobile {
    height: auto;
  }
}
</style>
